import React from "react";

const Image = ({ theme }) => (
  <svg width="161" height="160" viewBox="0 0 161 160" fill="none">
    <g clipPath="url(#clip0_5400_20380)">
      <mask
        id="mask0_5400_20380"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="160"
        height="160"
      >
        <rect
          width="160"
          height="160"
          transform="translate(1)"
          fill="url(#paint0_linear_5400_20380)"
        />
      </mask>
      <g mask="url(#mask0_5400_20380)">
        <g filter="url(#filter0_d_5400_20380)">
          <g clipPath="url(#clip1_5400_20380)">
            <path
              d="M13.5 86.1262C13.5 84.1702 14.2821 82.2954 15.6722 80.9192L24.3924 72.2866C27.2612 69.4466 31.8867 69.462 34.7365 72.3211L55.3849 93.0372C58.2482 95.9099 62.9004 95.9099 65.7637 93.0372L72.9888 85.7885C75.852 82.9158 80.5043 82.9158 83.3675 85.7885L102.73 105.214C105.598 108.091 110.259 108.086 113.12 105.202L135.631 82.513C140.239 77.8693 148.16 81.132 148.16 87.6735V114.774C148.16 121.856 142.419 127.597 135.338 127.597H26.3221C19.2407 127.597 13.5 121.856 13.5 114.774L13.5 86.1262Z"
              fill="#CCE0FF"
            />
            <circle cx="58.598" cy="57.0745" r="10.0745" fill="#CCE0FF" />
          </g>
          <rect
            x="14.5"
            y="36"
            width="132"
            height="88"
            rx="11"
            stroke="#0C66E4"
            strokeWidth="2"
          />
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5400_20380"
        x1="0"
        y1="160"
        x2="160.5"
        y2="160"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.293608" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_5400_20380">
        <rect
          width="160"
          height="160"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
      <clipPath id="clip1_5400_20380">
        <rect x="13.5" y="35" width="134" height="90" rx="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Image;
